<template>
  <validation-observer
    v-slot="propertyTypeObserver"
    key="type"
    slim
  >
    <form-section
      id="property-type"
      v-bind="propertyTypeObserver"
      :validated="formObserver.validated"
    >
      <form-row
        label="What type of property is it?"
      >
        <validation-provider
          v-slot="{ failed, failedRules }"
          name="Property Type"
          :vid="`${stepId}_property-type`"
          rules="required"
          slim
        >
          <radio
            v-model="propertyTypeModel"
            name="property-type"
            column
            wide
            :error="failed"
            :error-messages="getFieldErrors('propertyType', failedRules)"
            :items="propertyTypeItems"
            :data-test="snakeCase(questionFields.propertyType)"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from '@/components/questions/Base.vue';

export default {
  name: 'question-property-type',
  extends: QuestionBase,
  data () {
    return {
      fields: ['propertyType'],
    };
  },
  computed: {
    propertyTypeModel: {
      get () {
        if (this.helpers.isNull(this.questionData.propertyType)) return null;
        return this.questionData.propertyType.substring(1);
      },
      set (val) {
        this.questionData.propertyType = `${this.stepData.propertySort}${val}`;
      },
    },

    propertyTypeItems () {
      return this.helpers.createOptions({ source: this.constants.HOME_PROPERTY_TYPE[this.stepData.propertySort] || this.constants.HOME_PROPERTY_TYPE.H });
    },
  },
  created () {
    this.$watch('stepData.propertySort', val => {
      if (this.helpers.isNull(this.questionData.propertyType)) return; // property type not selected

      // if selected prop type not in list - reset it
      if (!this.propertyTypeItems.find(el => el.value === this.questionData.propertyType)) {
        this.questionData.propertyType = null;
      }
    });
  },
};
</script>
